import errorMessagesDe from 'plugins/i18n/errorMessages.de.ts'

export default {
	toast: {
		question: {
			discardChanges: 'Möchten Sie die Änderungen wirklich verwerfen?',
			deleteCis: 'Möchten Sie dieses Z.I.S. wirklich löschen?',
			deleteLinkedDocuments:
				'Sollen die verknüpften Dokumente auch gelöscht werden?',
			deleteNoteType: 'Möchten Sie die Notizart {name} wirklich löschen?',
			deleteCategory: 'Möchten Sie diese Kategorie wirklich löschen?',
			deleteImage: 'Möchten Sie dieses Bild wirklich löschen?',
			deleteSubcategory: 'Möchten Sie diese Unterkategorie wirklich löschen?',
			saveItem: 'Möchten Sie den {name} wirklich speichern?',
			approveOrRejectBookings:
				'Möchten Sie die wirklich alle Buchungen {status}?',
			discardUnsavedChanges:
				'Möchten Sie die nicht gespeicherten Änderungen wirklich verwerfen?',
			resetSettings: 'Möchten Sie die Einstellungen wirklich zurücksetzen?',
			existingAccountWarning:
				'Es existiert bereits ein Konto unter der angegebenen E-Mail Adresse. Das Passwort und das Profilbild werden nicht übernommen wenn Sie fortfahren! Möchten Sie eine andere E-Mail Adresse verwenden oder fortfahren?',
			deleteTeamMember:
				'Möchten Sie das Teammitglied {member} wirklich löschen?',
			deactivateTeamMember:
				'Möchten Sie das Teammitglied {member} deaktivieren? Es ist danach nicht mehr zuweisbar und hat keinen Zugriff mehr. Bestehende Zuordnungen bleiben erhalten.',
			activateTeamMember:
				'Möchten Sie das Teammitglied {member} wieder aktivieren?',
			deleteTemplate: 'Möchten Sie diese Vorlage wirklich löschen?',
			confirmCopyRoleSettings:
				'Möchten Sie die Einstellungen von der Personenfunktion {hp_id} - {name} übernehmen?',
			deleteDocument: 'Möchten Sie dieses Dokument wirklich löschen?',
			deleteDocumentOrFile:
				'Möchten Sie das Dokument mit <b>{count} Dateien</b> oder die Datei <b class=\\"d-inline-block text-truncate\\" style=\\"max-width: 150px;line-height: 10px\\">{fileNotes}</b> löschen?',
			deleteFaqCategory: 'Möchten Sie diese FAQ Kategorie wirklich löschen?',
			deleteFaqEntry: 'Möchten Sie den FAQ Eintrag wirklich löschen?',
			noteVisibilityWarnText:
				'Diese Notiz wird für @.lower:{visibleUsers} Nutzer sichtbar sein und @.lower:{notifiedUsers} Nutzer werden über diese benachrichtigt, weil keine Liegenschaft ausgewählt wurde. Möchten Sie fortfahren?',
			deleteNote: 'Möchten Sie diese Notiz wirklich löschen?',
			deleteTask: 'Möchten Sie diese Wiedervorlage wirklich löschen?',
			sendCredentials:
				'Möchten Sie wirklich die Zugangsdaten versenden? Hierbei wird das bestehende Passwort überschrieben',
			discardChanges:
				'Es gibt ungesicherte Änderungen. Möchten Sie diese verwerfen?',
			deleteContainerOrUnlink:
				'Möchten Sie den Container löschen oder die Verknüpfung entfernen?',
			deleteDocumentType: 'Möchten Sie diese Dokumentenart wirklich löschen?',
			deleteDocumentTypeWithDocs:
				'Möchten Sie diese Dokumentenart wirklich löschen? <span style="font-weight: bold; color: #fff">Es werden alle Dokumente mit dieser Dokumentenart gelöscht.</span>',
			deleteComment: 'Möchten Sie den Kommentar wirklich löschen?',
			deleteRoom: 'Möchten Sie den Raum {roomName} wirklich entfernen?',
			releaseProtocol:
				'Möchten Sie wirklich fortfahren und das Protokoll zur Unterschrift freigeben?<br />Änderungen sind anschließend nicht mehr möglich.',
			confirmDeletePersonalData:
				'Bitte bestätigen Sie, dass Ihre persönlichen Daten aus dem Portal gelöscht werden sollen und Ihr Verwalter informiert wird.',
			sendReminderToAll:
				'Möchten Sie die wirklich eine Erinnerung an alle ausgewählten Personen senden?',
		},
		success: {
			copied_singular: '@:{element} wurde kopiert',
			copied_plural: '@:{element} wurden kopiert',
			updated_singular: '@:{element} wurde aktualisiert',
			updated_plural: '@:{element} wurden aktualisiert',
			created_singular: '@:{element} wurde angelegt',
			created_plural: '@:{element} wurden angelegt',
			deleted_singular: '@:{element} wurde gelöscht',
			deleted_plural: '@:{element} wurden gelöscht',
			saved_singular: '@:{element} wurde gespeichert!',
			edited_singular: '@:{element} wurde bearbeitet',
			sent_singular: '@:{element} wurde versendet!',
			sent_plural: '@:{element} wurden versendet',
			/**/
			emailTemplateUpdate: 'Ihre E-Mail Vorlagen wurde aktualisiert',
			emailSent: 'Eine E-Mail wurde an Ihre Adresse gesendet',
			passwordSaved: 'Ihr Passwort wurde gespeichert',
			passwordUpdated: 'Ihr Passwort wurde aktualisiert',
			settingsCopied: 'Einstellungen wurden kopiert',
			permissionsUpdated: 'Berechtigungen wurden aktualisiert',
			linkedContractsUpdated:
				'Die verküpften Verträge wurden erfolgreich aktualisiert',
			reminderSent: 'Es wurden {length} Erinnerungen versendet',
			commentCreated: 'Kommentar erfolgreich erstellt',
			commentAndEmailSent: 'Kommentar und Email erfolgreich versendet',
			meterReadingReleased: 'Zählerstand erfolgreich freigegeben',
			meterReadingRejected: 'Zählerstand erfolgreich abgelehnt',
			meterReadingsUpdated: 'Zählerstände erfolgreich aktualisiert',
			reportToInsurance:
				'Die Meldung wurde erfolgreich bei der Versicherung eingereicht',
			linksUpdated: 'Verknüpfungen erfolgreich aktualisiert',
			requestProcessed: 'Die Anfrage wurde bearbeitet.',
			requestSent: 'Die Anfrage wurde versendet',
			reportSubmitted: 'Ihre Meldung wurde erfolgreich übermittelt!',
			reviewersStored: 'Prüfer wurden hinterlegt',
			protocolCreationFailed: 'Fehler beim Erstellen des Protokolls.',
			protocolCreated: 'Das Protokoll wurde erstellt',
			welcomeEmailSent: 'Begrüßungsemail wurde versendet!',
			deletedSelection: '{value} {name}',
			welcomeEmailsSent: '{count} Begrüßungsemail(s)',
			invitationsSent: '{count} Einladungen wurden versendet',
			documentsUpdated: 'Ihre Dokumente wurden erfolgreich aktualisiert',
			settingsUpdated: 'Ihre Einstellungen wurden aktualisiert',
		},
		info: {
			maintenanceNotice: {
				title: 'Wichtiger Hinweis',
				notifications:
					'Wegen Wartungsarbeiten werden derzeit keine Benachrichtigungen versendet.',
			},
			noFilesInContainer:
				'Es existieren keine Dateien in dem hinterlegten Container.',
			sessionExpired:
				'Ihre Sitzung ist abgelaufen. Sie wurden automatisch abgemeldet.',
			introDismissed:
				'Es werden Ihnen keine weiteren Einführungsinformationen mehr angezeigt.<br />Sie können die Tour jederzeit unter „Profil → Einstellungen" erneut starten.',
			tasksEdit:
				'Bereits übertragene Wiedervorlagen können nur in HausPerfekt bearbeitet werden!',
			noDataRedirected:
				'Keine Daten vorhanden. Sie wurden automatisch weitergeleitet.',
			actingAsUser:
				'Sie agieren nun als <b>{email}</b>!<br /> Über das Profil-Symbol oben rechts können Sie jederzeit zu Ihrem eigenen Account zurückkehren.',
			actingAsSelf: 'Sie agieren nun als Sie selbst.',
			confirmResetMessage:
				'Durch die Bestätigung werden bestimmte Eingaben zurückgesetzt, um die Datenbeziehungen konsistent zu halten. {value}',
		},
		error: {
			applicationUnavailable:
				'Zurzeit ist die Anwendung nicht erreichbar. Versuchen Sie es bitte zu einem späteren Zeitpunkt.',
			applicationInMaintenance:
				'Die Anwendung befindet sich in Wartung. Bitte versuchen Sie es später erneut.',
			applicationInvalidSubdomain:
				'Die aufgerufene Adresse ist ungültig. Bitte überprüfen Sie die Adresse und laden Sie die Seite anschließend erneut.',
			address_creation_failed: 'Adressenerstellung fehlgeschlagen',
			passwordSaveFailed:
				'<b>Ihr Passwort konnte nicht gespeichert werden.</b><br /> Entweder wurde nicht die richtige E-Mail Adresse angegeben oder die Passwortanfrage ist nicht mehr gültig.<br /> Bitte versuchen Sie es erneut!',
			element: 'Das Element',
			elementNotDeleted:
				'@:{entity} konnte nicht gelöscht werden weil es noch von anderen Daten verwendet wird!',
			incorrectCurrentPassword: 'Das bisherige Passwort ist nicht korrekt',
			placeholderNotCopied:
				'Leider konnte der Platzhalter nicht kopiert werden!',
			invalidData:
				'Ungültige Daten! Bitte kopieren Sie die gewünschten Daten erneut',
			dataSaveFailed: 'Fehler beim Speichern der Daten',
			dataLoadFailed: 'Fehler beim Laden der Daten',
			protocolLoadIncomplete:
				'Nicht alle Daten konnten geladen werden. Das Protokoll ist möglicherweise unvollständig – bitte schließen Sie den Dialog und versuchen Sie es erneut.',
			noDocumentTypeDefined:
				'Es wurde noch keine Dokumentenart für das <b>Protokoll</b> definiert. Klicken Sie bitte <a href="/administration/settings/generic">hier</a> um die notwendige Änderung vorzunehmen.',
			noteCreationFailed:
				'Etwas ist bei der Notizerstellung schiefgelaufen, bitte versuchen Sie es erneut',
			noPermission: 'Keine Berechtigung',
			noPermissionDetails:
				'Ihre Zugangsdaten sind korrekt aber es sind keine weiteren Daten zu Ihrem Zugang verknüpft. Bitte wenden Sie sich an Ihren Verwalter.',
			defaultLoginError:
				'Während der Anmeldung ist ein Fehler aufgetreten, versuchen Sie es bitte zu einem späteren Zeitpunkt erneut.',
			loginFailed: 'Anmeldung fehlgeschlagen',
			errorMessages: errorMessagesDe,
			teamMemberNotCreated:
				'Das Teammitglied konnte nicht angelegt werden weil bereits ein Teammitglied mit derselben E-Mail Adresse existiert',
			meterReadingNotAccepted: 'Zählerstand wurde nicht übernommen!',
			meterReadingNotSaved:
				'Der Zählerstand konnte nicht gespeichert werden weil bereits ein Zählerstand übermittelt wurde, der zur Freigabe vorliegt und einen höheren Wert {value} hat.',
			subjectRequired: 'Betreff ist ein Pflichtfeld',
			recipientRequired: 'Bitte wählen Sie einen Empfänger aus',
			notAllItemsDeleted: 'Es konnten nicht alle @:{name} gelöscht werden',
			notificationNotSent:
				'Eine Benachrichtigung zu der Notiz: <b>${updatedNote.subject}</b>, konnte nicht gesendet werden',
			noteUpdateFailed:
				'Etwas ist bei der Aktualisierung der Notiz schiefgelaufen, bitte versuchen Sie es erneut',
			fileNotFound: 'Die Datei ist leider nicht vorhanden!',
			reportInsuranceFailed: 'Fehler beim Laden der Versicherungsmeldung',
			genericError: 'Ein Fehler ist aufgetreten',
			userAccountsLoadFailed: 'Fehler beim Laden der Benutzerkonten',
			sendingWelcomeEmailsFailed: 'Error sending welcome emails',
			addAtLeastOneFile: 'Bitte fügen Sie mindestens eine Datei hinzu.',
			genericRetryError:
				'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut',
			maxFilesExceeded: 'Sie können höchstens {maxFiles} Datei(en) auswählen',
			filesExceedMaxSize:
				'Einige Dateien überschreiten die maximale Größe von {maxSize} MB',
			unsupportedFileType: 'Nicht unterstütztes Dateiformat: {files}',
			fileDownloadFailed: 'Fehler beim Herunterladen der Datei!',
			tooManyAttempts:
				'Zu viele fehlerhafte Versuche! Warten Sie bitte ein paar Minuten und versuchen Sie es erneut.',
			invalidAccessAtAddress:
				'Unter der angegeben Adresse gibt es keinen gültigen Zugang. <br />Bitte überprüfen Sie die Schreibweise oder kontaktieren Sie Ihre Hausverwaltung.',
		},
	},
}
